import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class HealthDashboardRoute extends Route {
  @service featureFlags;
  @service router;
  @service state;
  @service integrationTelemetryConfig;

  titleToken = 'Health Dashboard';

  async beforeModel() {
    if (!this.featureFlags.isEnabled('integration-health-dashboard')) {
      return void this.router.transitionTo('unauthorized');
    }
    const locationId = this.state.currentLocation?.id;
    if (locationId) {
      await this.integrationTelemetryConfig.loadForLocation(String(locationId));
      if (!this.integrationTelemetryConfig.hasDataForLocation) {
        return void this.router.transitionTo('unauthorized');
      }
    }
  }

  async setupController(controller, model) {
    super.setupController(controller, model);
    controller.showLocationFilter = false;
    const locationId = controller.state.currentLocation?.id;
    controller.selectedLocations = locationId != null ? [String(locationId)] : [];
    controller.selectedInstalls = [];
    controller.selectedEventTypes = [];
    controller.selectedIntegrationTypes = [];
    controller.selectedStatuses = [];
    controller.page = 1;
    controller._hiddenEventTypes = [];
    controller._hiddenInstalls = [];
    await controller.fetchData();
    controller.startAutoRefresh();
  }

  deactivate() {
    this.controller.stopAutoRefresh();
  }
}
